import { apiClient } from '@/api/api'
import type { Person, PersonPayload } from '@/types/people'

export const getPeople = async (): Promise<Person[]> => {
  const response = await apiClient.get<{ profiles: Person[] }>('/user-profile/profiles')
  return response.data.profiles ?? []
}

export const createPerson = async (payload: PersonPayload): Promise<Person> => {
  const response = await apiClient.post<{ profile: Person }>('/user-profile/profiles', payload)
  return response.data.profile
}

export const updatePerson = async (id: number, payload: PersonPayload): Promise<Person> => {
  const response = await apiClient.put<{ profile: Person }>(`/user-profile/profiles/${id}`, payload)
  return response.data.profile
}

export const deletePerson = async (id: number): Promise<void> => {
  await apiClient.delete(`/user-profile/profiles/${id}`)
}
